{********************************************************************}
{                                                                    }
{ written by TMS Software                                            }
{            Copyright (c) 2025                                      }
{            Email : info@tmssoftware.com                            }
{            Web : http://www.tmssoftware.com                        }
{                                                                    }
{ The source code is given as is. The author is not responsible      }
{ for any possible damage done due to the use of this code.          }
{ The complete source code remains property of the author and may    }
{ not be distributed, published, given or sold in any form as such.  }
{ No parts of the source code can be included in any other component }
{ or application without written authorization of the author.        }
{********************************************************************}

unit WEBLib.DataGrid.CellComponents;

{$IFDEF PAS2JS}
{$mode DELPHI}
{$modeswitch externalclass}
{$ENDIF}

interface
uses
  Classes, web, JS, WEBLib.Controls, Types, System.SysUtils, jsdelphisystem, WEBLib.DataGrid.libjs;

type
  TEmbeddedJSCellComponents = class {$IFDEF PAS2JS}external name 'document.agCellComp'{$ENDIF} (TJSObject)
  public
{$REGION 'JavaScript Exports'}
    class var TceCheckboxEditorComponent: TJSFunction;
    class var TceNoneEditorComponent: TJSFunction;
    class var TceMemoEditorComponent: TJSFunction;
    class var TceComboEditorComponent: TJSFunction;
    class var TceMaskEditorComponent: TJSFunction;
    class var TceTelEditorComponent: TJSFunction;
    class var TceEmailEditorComponent: TJSFunction;
    class var TceURLEditorComponent: TJSFunction;
    class var TceMonthEditorComponent: TJSFunction;
    class var TceWeekEditorComponent: TJSFunction;
    class var TceColorEditorComponent: TJSFunction;
    class var TceRangeEditorComponent: TJSFunction;
    class var TceTimeEditorComponent: TJSFunction;
    class var TceDateEditorComponent: TJSFunction;
    class var TceNumberEditorComponent: TJSFunction;
    class var TceTextEditorComponent: TJSFunction;
    class var EditorComponentTextAreaBase: TJSFunction;
    class var EditorComponentInputBase: TJSFunction;
    class var TcrCheckboxRendererComponent: TJSFunction;
    class var TcrTelRendererComponent: TJSFunction;
    class var TcrEmailRendererComponent: TJSFunction;
    class var TcrURLRendererComponent: TJSFunction;
    class var TcrImageRendererComponent: TJSFunction;
    class var TcrTextRendererComponent: TJSFunction;
    class var RendererComponentImageBase: TJSFunction;
{$ENDREGION}
  end;

  TDGCellComponents = class(TEmbeddedJavaScript)
  public

    function ModuleName: String; override;
    function Source: String; override;
    function GlobalVariableName: String; override;
    class function GetExports: TDGCellComponents;
  end;
{$REGION 'Notes'}(*
Text
Number
Date
Time
Range
Color
Week
Month
URL
Email
Tel
Mask
Combo
Memo
None
Custom
Checkbox
Combobox
Date/time
Picker/color picker
*){$ENDREGION}

implementation


{ TDGCellComponents }

class function TDGCellComponents.GetExports: TDGCellComponents;
begin
  Result := nil;
{$IFDEF PAS2JS}asm
  if (typeof(document.agCellComp) != "undefined")
    this.Result = document.agCellComp;
end;{$ENDIF}
end;

function TDGCellComponents.GlobalVariableName: String;
begin
  Result := 'agCellComp';
end;

function TDGCellComponents.ModuleName: String;
begin
  Result := ClassName;
end;

function TDGCellComponents.Source: String;
var
  S: String;
begin
  S := '';
{$REGION 'TDGCellComponents'}
{$IFDEF PAS2JS}
  S:=S+'"use strict";'+#$D#$A;
  S:=S+'Object.defineProperty(exports, "__esModule", { value: true });'+#$D#$A;
  S:=S+'exports.TestEditorComponent = exports.TestRendererComponent = exports.TceCheckboxEditorComponent = exports.TceNoneEditorComponent = exports.TceMemoEditorComponent = exports.TceComboEditorComponent = exports.TceMaskEditorComponent = exports.TceTelEditorComponent = exports.TceEmailEditorComponent = exports.TceURLEditorComponent = exports.TceMonthEditorComponent = exports.TceWeekEditorComponent = exports.TceColorEditorComponent = exports.TceRangeEditorComponent = exports.TceTimeEditorComponent = exports.TceDateEditorComponent = exports.TceNumberEditorComponent = exports.TceTextEditorComponent = exports.EditorComponentTextAreaBase = exports.EditorComponentInputBase = exports.TcrCheckboxRendererComponent = exports.TcrTelRendererComponent = exports.TcrEmailRendererComponent = exports.TcrURLRendererComponent = exports.TcrImageRendererComponent = exports.TcrTextRendererComponent = exports.RendererComponentImageBase = void 0;'+#$D#$A;
  S:=S+'let Result = {};'+#$D#$A;
  S:=S+'class RendererComponentImageBase {'+#$D#$A;
  S:=S+'    init(params) {'+#$D#$A;
  S:=S+'        this.gui = document.createElement("div");'+#$D#$A;
  S:=S+'    }'+#$D#$A;
  S:=S+'    destroy() {'+#$D#$A;
  S:=S+'    }'+#$D#$A;
  S:=S+'    getGui() {'+#$D#$A;
  S:=S+'        return this.gui;'+#$D#$A;
  S:=S+'    }'+#$D#$A;
  S:=S+'    refresh(params) {'+#$D#$A;
  S:=S+'        return (false);'+#$D#$A;
  S:=S+'    }'+#$D#$A;
  S:=S+'}'+#$D#$A;
  S:=S+'exports.RendererComponentImageBase = RendererComponentImageBase;'+#$D#$A;
  S:=S+'class TcrTextRendererComponent extends RendererComponentImageBase {'+#$D#$A;
  S:=S+'    init(params) {'+#$D#$A;
  S:=S+'        super.init(params);'+#$D#$A;
  S:=S+'        this.gui.innerHTML = params.value;'+#$D#$A;
  S:=S+'    }'+#$D#$A;
  S:=S+'}'+#$D#$A;
  S:=S+'exports.TcrTextRendererComponent = TcrTextRendererComponent;'+#$D#$A;
  S:=S+'class TcrImageRendererComponent extends RendererComponentImageBase {'+#$D#$A;
  S:=S+'    init(params) {'+#$D#$A;
  S:=S+'        super.init(params);'+#$D#$A;
  S:=S+'        if (typeof (params.value) == "string"'+#$D#$A;
  S:=S+'            && params.value.length > 0) {'+#$D#$A;
  S:=S+'            this.image = document.createElement("img");'+#$D#$A;
  S:=S+'            this.image.src = params.value;'+#$D#$A;
  S:=S+'            this.image.style.setProperty("width", "100%");'+#$D#$A;
  S:=S+'            this.image.style.setProperty("height", "100%");'+#$D#$A;
  S:=S+'            this.image.style.setProperty("object-fit", "contain");'+#$D#$A;
  S:=S+'            this.gui.classList.add("cr-image");'+#$D#$A;
  S:=S+'            this.gui.appendChild(this.image);'+#$D#$A;
  S:=S+'        }'+#$D#$A;
  S:=S+'    }'+#$D#$A;
  S:=S+'}'+#$D#$A;
  S:=S+'exports.TcrImageRendererComponent = TcrImageRendererComponent;'+#$D#$A;
  S:=S+'class TcrURLRendererComponent extends RendererComponentImageBase {'+#$D#$A;
  S:=S+'    init(params) {'+#$D#$A;
  S:=S+'        super.init(params);'+#$D#$A;
  S:=S+'        this.anchor = document.createElement("a");'+#$D#$A;
  S:=S+'        this.anchor.href = params.value;'+#$D#$A;
  S:=S+'        this.anchor.innerText = params.value;'+#$D#$A;
  S:=S+'        this.gui.classList.add("cr-url");'+#$D#$A;
  S:=S+'        this.gui.appendChild(this.anchor);'+#$D#$A;
  S:=S+'    }'+#$D#$A;
  S:=S+'}'+#$D#$A;
  S:=S+'exports.TcrURLRendererComponent = TcrURLRendererComponent;'+#$D#$A;
  S:=S+'class TcrEmailRendererComponent extends RendererComponentImageBase {'+#$D#$A;
  S:=S+'    init(params) {'+#$D#$A;
  S:=S+'        super.init(params);'+#$D#$A;
  S:=S+'        this.anchor = document.createElement("a");'+#$D#$A;
  S:=S+'        this.anchor.href = "mailto:" + params.value;'+#$D#$A;
  S:=S+'        this.anchor.innerText = params.value;'+#$D#$A;
  S:=S+'        this.gui.classList.add("cr-email");'+#$D#$A;
  S:=S+'        this.gui.appendChild(this.anchor);'+#$D#$A;
  S:=S+'    }'+#$D#$A;
  S:=S+'}'+#$D#$A;
  S:=S+'exports.TcrEmailRendererComponent = TcrEmailRendererComponent;'+#$D#$A;
  S:=S+'class TcrTelRendererComponent extends RendererComponentImageBase {'+#$D#$A;
  S:=S+'    init(params) {'+#$D#$A;
  S:=S+'        super.init(params);'+#$D#$A;
  S:=S+'        this.anchor = document.createElement("a");'+#$D#$A;
  S:=S+'        this.anchor.href = "tel:" + params.value;'+#$D#$A;
  S:=S+'        this.anchor.innerText = params.value;'+#$D#$A;
  S:=S+'        this.gui.classList.add("cr-tel");'+#$D#$A;
  S:=S+'        this.gui.appendChild(this.anchor);'+#$D#$A;
  S:=S+'    }'+#$D#$A;
  S:=S+'}'+#$D#$A;
  S:=S+'exports.TcrTelRendererComponent = TcrTelRendererComponent;'+#$D#$A;
  S:=S+'class TcrCheckboxRendererComponent extends RendererComponentImageBase {'+#$D#$A;
  S:=S+'    init(params) {'+#$D#$A;
  S:=S+'        super.init(params);'+#$D#$A;
  S:=S+'        this.gui.classList.add("cr-checkbox");'+#$D#$A;
  S:=S+'        this.gui.innerHTML = params.value;'+#$D#$A;
  S:=S+'    }'+#$D#$A;
  S:=S+'}'+#$D#$A;
  S:=S+'exports.TcrCheckboxRendererComponent = TcrCheckboxRendererComponent;'+#$D#$A;
  S:=S+'class EditorComponentInputBase {'+#$D#$A;
  S:=S+'    init(params) {'+#$D#$A;
  S:=S+'        this.gui = document.createElement("input");'+#$D#$A;
  S:=S+'        this.gui.type = "text";'+#$D#$A;
  S:=S+'        this.gui.style.fontSize = "calc(var(--ag-font-size) + 1px)";'+#$D#$A;
  S:=S+'        this.gui.style.fontFamily = "var(--ag-font-family)";'+#$D#$A;
  S:=S+'        this.gui.style.width = "calc(100% - var(--ag-cell-horizontal-padding) - 1px + var(--ag-row-group-indent-size) * var(--ag-indentation-level))";'+#$D#$A;
  S:=S+'        this.gui.style.height = "100%";'+#$D#$A;
  S:=S+'        this.gui.style.border = "none";'+#$D#$A;
  S:=S+'        this.gui.style.outline = "none";'+#$D#$A;
  S:=S+'        this.gui.style.fontWeight = "unset";'+#$D#$A;
  S:=S+'        this._paramsInit(params);'+#$D#$A;
  S:=S+'    }'+#$D#$A;
  S:=S+'    postInit(params) {'+#$D#$A;
  S:=S+'        this.gui.classList.add("ag-cell");'+#$D#$A;
  S:=S+'    }'+#$D#$A;
  S:=S+'    _paramsInit(params) {'+#$D#$A;
  S:=S+'        this.params = params;'+#$D#$A;
  S:=S+'        let startValue = params.value;'+#$D#$A;
  S:=S+'        const eventKey = params.eventKey;'+#$D#$A;
  S:=S+'        const isBackspace = eventKey === "Backspace";'+#$D#$A;
  S:=S+'        if (isBackspace) {'+#$D#$A;
  S:=S+'            startValue = "";'+#$D#$A;
  S:=S+'        }'+#$D#$A;
  S:=S+'        else if (eventKey && eventKey.length === 1) {'+#$D#$A;
  S:=S+'            startValue = eventKey;'+#$D#$A;
  S:=S+'        }'+#$D#$A;
  S:=S+'        if (startValue !== null && startValue !== undefined) {'+#$D#$A;
  S:=S+'            this.gui.value = startValue;'+#$D#$A;
  S:=S+'        }'+#$D#$A;
  S:=S+'    }'+#$D#$A;
  S:=S+'    destroy() {'+#$D#$A;
  S:=S+'    }'+#$D#$A;
  S:=S+'    getGui() {'+#$D#$A;
  S:=S+'        return this.gui;'+#$D#$A;
  S:=S+'    }'+#$D#$A;
  S:=S+'    getValue() {'+#$D#$A;
  S:=S+'        console.log("***** EditorComponentInputBase.getValue()");'+#$D#$A;
  S:=S+'        return (this.gui.value);'+#$D#$A;
  S:=S+'    }'+#$D#$A;
  S:=S+'    afterGuiAttached() {'+#$D#$A;
  S:=S+'        this.gui.focus();'+#$D#$A;
  S:=S+'    }'+#$D#$A;
  S:=S+'    isCancelBeforeStart() {'+#$D#$A;
  S:=S+'        console.log("***** EditorComponentInputBase.isCancelBeforeStart()");'+#$D#$A;
  S:=S+'        return (false);'+#$D#$A;
  S:=S+'    }'+#$D#$A;
  S:=S+'}'+#$D#$A;
  S:=S+'exports.EditorComponentInputBase = EditorComponentInputBase;'+#$D#$A;
  S:=S+'class EditorComponentTextAreaBase {'+#$D#$A;
  S:=S+'    init(params) {'+#$D#$A;
  S:=S+'        this.gui = document.createElement("textarea");'+#$D#$A;
  S:=S+'        this._paramsInit(params);'+#$D#$A;
  S:=S+'    }'+#$D#$A;
  S:=S+'    postInit(params) {'+#$D#$A;
  S:=S+'        this.gui.classList.add("ag-cell");'+#$D#$A;
  S:=S+'    }'+#$D#$A;
  S:=S+'    _paramsInit(params) {'+#$D#$A;
  S:=S+'        this.params = params;'+#$D#$A;
  S:=S+'        let startValue = params.value;'+#$D#$A;
  S:=S+'        const eventKey = params.eventKey;'+#$D#$A;
  S:=S+'        const isBackspace = eventKey === "Backspace";'+#$D#$A;
  S:=S+'        if (isBackspace) {'+#$D#$A;
  S:=S+'            startValue = "";'+#$D#$A;
  S:=S+'        }'+#$D#$A;
  S:=S+'        else if (eventKey && eventKey.length === 1) {'+#$D#$A;
  S:=S+'            startValue = eventKey;'+#$D#$A;
  S:=S+'        }'+#$D#$A;
  S:=S+'        if (startValue !== null && startValue !== undefined) {'+#$D#$A;
  S:=S+'            this.gui.value = startValue;'+#$D#$A;
  S:=S+'        }'+#$D#$A;
  S:=S+'    }'+#$D#$A;
  S:=S+'    destroy() {'+#$D#$A;
  S:=S+'    }'+#$D#$A;
  S:=S+'    getGui() {'+#$D#$A;
  S:=S+'        return this.gui;'+#$D#$A;
  S:=S+'    }'+#$D#$A;
  S:=S+'    getValue() {'+#$D#$A;
  S:=S+'        this.gui.focus();'+#$D#$A;
  S:=S+'    }'+#$D#$A;
  S:=S+'}'+#$D#$A;
  S:=S+'exports.EditorComponentTextAreaBase = EditorComponentTextAreaBase;'+#$D#$A;
  S:=S+'class TceTextEditorComponent extends EditorComponentInputBase {'+#$D#$A;
  S:=S+'    init(params) {'+#$D#$A;
  S:=S+'        super.init(params);'+#$D#$A;
  S:=S+'        this.gui.type = "text";'+#$D#$A;
  S:=S+'        this.gui.classList.add("ce-text");'+#$D#$A;
  S:=S+'        super.postInit(params);'+#$D#$A;
  S:=S+'    }'+#$D#$A;
  S:=S+'}'+#$D#$A;
  S:=S+'exports.TceTextEditorComponent = TceTextEditorComponent;'+#$D#$A;
  S:=S+'class TceNumberEditorComponent extends EditorComponentInputBase {'+#$D#$A;
  S:=S+'    init(params) {'+#$D#$A;
  S:=S+'        super.init(params);'+#$D#$A;
  S:=S+'        this.gui.type = "number";'+#$D#$A;
  S:=S+'        this.gui.classList.add("ce-number");'+#$D#$A;
  S:=S+'        super.postInit(params);'+#$D#$A;
  S:=S+'    }'+#$D#$A;
  S:=S+'    getValue() {'+#$D#$A;
  S:=S+'        console.log("***** TceNumberEditorComponent.getValue()");'+#$D#$A;
  S:=S+'        return (parseInt(this.gui.value));'+#$D#$A;
  S:=S+'    }'+#$D#$A;
  S:=S+'}'+#$D#$A;
  S:=S+'exports.TceNumberEditorComponent = TceNumberEditorComponent;'+#$D#$A;
  S:=S+'class TceDateEditorComponent extends EditorComponentInputBase {'+#$D#$A;
  S:=S+'    init(params) {'+#$D#$A;
  S:=S+'        super.init(params);'+#$D#$A;
  S:=S+'        this.gui.type = "date";'+#$D#$A;
  S:=S+'        this.gui.classList.add("ce-date");'+#$D#$A;
  S:=S+'        super.postInit(params);'+#$D#$A;
  S:=S+'    }'+#$D#$A;
  S:=S+'}'+#$D#$A;
  S:=S+'exports.TceDateEditorComponent = TceDateEditorComponent;'+#$D#$A;
  S:=S+'class TceTimeEditorComponent extends EditorComponentInputBase {'+#$D#$A;
  S:=S+'    init(params) {'+#$D#$A;
  S:=S+'        super.init(params);'+#$D#$A;
  S:=S+'        this.gui.type = "time";'+#$D#$A;
  S:=S+'        this.gui.classList.add("ce-time");'+#$D#$A;
  S:=S+'        super.postInit(params);'+#$D#$A;
  S:=S+'    }'+#$D#$A;
  S:=S+'}'+#$D#$A;
  S:=S+'exports.TceTimeEditorComponent = TceTimeEditorComponent;'+#$D#$A;
  S:=S+'class TceRangeEditorComponent extends EditorComponentInputBase {'+#$D#$A;
  S:=S+'    init(params) {'+#$D#$A;
  S:=S+'        super.init(params);'+#$D#$A;
  S:=S+'        this.gui.type = "range";'+#$D#$A;
  S:=S+'        this.gui.classList.add("ce-range");'+#$D#$A;
  S:=S+'        this.gui.min = "0";'+#$D#$A;
  S:=S+'        this.gui.max = "100";'+#$D#$A;
  S:=S+'        this.gui.step = "1";'+#$D#$A;
  S:=S+'        super.postInit(params);'+#$D#$A;
  S:=S+'    }'+#$D#$A;
  S:=S+'}'+#$D#$A;
  S:=S+'exports.TceRangeEditorComponent = TceRangeEditorComponent;'+#$D#$A;
  S:=S+'class TceColorEditorComponent extends EditorComponentInputBase {'+#$D#$A;
  S:=S+'    init(params) {'+#$D#$A;
  S:=S+'        super.init(params);'+#$D#$A;
  S:=S+'        this.gui.type = "color";'+#$D#$A;
  S:=S+'        this.gui.classList.add("ce-color");'+#$D#$A;
  S:=S+'        super.postInit(params);'+#$D#$A;
  S:=S+'    }'+#$D#$A;
  S:=S+'}'+#$D#$A;
  S:=S+'exports.TceColorEditorComponent = TceColorEditorComponent;'+#$D#$A;
  S:=S+'class TceWeekEditorComponent extends EditorComponentInputBase {'+#$D#$A;
  S:=S+'    init(params) {'+#$D#$A;
  S:=S+'        super.init(params);'+#$D#$A;
  S:=S+'        this.gui.type = "week";'+#$D#$A;
  S:=S+'        this.gui.classList.add("ce-week");'+#$D#$A;
  S:=S+'        super.postInit(params);'+#$D#$A;
  S:=S+'    }'+#$D#$A;
  S:=S+'}'+#$D#$A;
  S:=S+'exports.TceWeekEditorComponent = TceWeekEditorComponent;'+#$D#$A;
  S:=S+'class TceMonthEditorComponent extends EditorComponentInputBase {'+#$D#$A;
  S:=S+'    init(params) {'+#$D#$A;
  S:=S+'        super.init(params);'+#$D#$A;
  S:=S+'        this.gui.type = "month";'+#$D#$A;
  S:=S+'        this.gui.classList.add("ce-month");'+#$D#$A;
  S:=S+'        super.postInit(params);'+#$D#$A;
  S:=S+'    }'+#$D#$A;
  S:=S+'}'+#$D#$A;
  S:=S+'exports.TceMonthEditorComponent = TceMonthEditorComponent;'+#$D#$A;
  S:=S+'class TceURLEditorComponent extends EditorComponentInputBase {'+#$D#$A;
  S:=S+'    init(params) {'+#$D#$A;
  S:=S+'        super.init(params);'+#$D#$A;
  S:=S+'        this.gui.type = "url";'+#$D#$A;
  S:=S+'        this.gui.classList.add("ce-url");'+#$D#$A;
  S:=S+'        super.postInit(params);'+#$D#$A;
  S:=S+'    }'+#$D#$A;
  S:=S+'}'+#$D#$A;
  S:=S+'exports.TceURLEditorComponent = TceURLEditorComponent;'+#$D#$A;
  S:=S+'class TceEmailEditorComponent extends EditorComponentInputBase {'+#$D#$A;
  S:=S+'    init(params) {'+#$D#$A;
  S:=S+'        super.init(params);'+#$D#$A;
  S:=S+'        this.gui.type = "email";'+#$D#$A;
  S:=S+'        this.gui.classList.add("ce-email");'+#$D#$A;
  S:=S+'        super.postInit(params);'+#$D#$A;
  S:=S+'    }'+#$D#$A;
  S:=S+'}'+#$D#$A;
  S:=S+'exports.TceEmailEditorComponent = TceEmailEditorComponent;'+#$D#$A;
  S:=S+'class TceTelEditorComponent extends EditorComponentInputBase {'+#$D#$A;
  S:=S+'    init(params) {'+#$D#$A;
  S:=S+'        super.init(params);'+#$D#$A;
  S:=S+'        this.gui.type = "tel";'+#$D#$A;
  S:=S+'        this.gui.classList.add("ce-tel");'+#$D#$A;
  S:=S+'        super.postInit(params);'+#$D#$A;
  S:=S+'    }'+#$D#$A;
  S:=S+'}'+#$D#$A;
  S:=S+'exports.TceTelEditorComponent = TceTelEditorComponent;'+#$D#$A;
  S:=S+'class TceMaskEditorComponent extends EditorComponentInputBase {'+#$D#$A;
  S:=S+'    init(params) {'+#$D#$A;
  S:=S+'        super.init(params);'+#$D#$A;
  S:=S+'        this.gui.type = "text";'+#$D#$A;
  S:=S+'        this.gui.classList.add("ce-mask");'+#$D#$A;
  S:=S+'        super.postInit(params);'+#$D#$A;
  S:=S+'    }'+#$D#$A;
  S:=S+'}'+#$D#$A;
  S:=S+'exports.TceMaskEditorComponent = TceMaskEditorComponent;'+#$D#$A;
  S:=S+'class TceComboEditorComponent extends EditorComponentInputBase {'+#$D#$A;
  S:=S+'    init(params) {'+#$D#$A;
  S:=S+'        super.init(params);'+#$D#$A;
  S:=S+'        this.gui.type = "text";'+#$D#$A;
  S:=S+'        this.gui.classList.add("ce-combo");'+#$D#$A;
  S:=S+'        super.postInit(params);'+#$D#$A;
  S:=S+'    }'+#$D#$A;
  S:=S+'}'+#$D#$A;
  S:=S+'exports.TceComboEditorComponent = TceComboEditorComponent;'+#$D#$A;
  S:=S+'class TceMemoEditorComponent extends EditorComponentTextAreaBase {'+#$D#$A;
  S:=S+'    init(params) {'+#$D#$A;
  S:=S+'        super.init(params);'+#$D#$A;
  S:=S+'        this.gui.classList.add("ce-memo");'+#$D#$A;
  S:=S+'        super.postInit(params);'+#$D#$A;
  S:=S+'    }'+#$D#$A;
  S:=S+'}'+#$D#$A;
  S:=S+'exports.TceMemoEditorComponent = TceMemoEditorComponent;'+#$D#$A;
  S:=S+'class TceNoneEditorComponent {'+#$D#$A;
  S:=S+'    init(params) {'+#$D#$A;
  S:=S+'        this.gui = document.createElement("div");'+#$D#$A;
  S:=S+'        this.gui.classList.add("ce-none");'+#$D#$A;
  S:=S+'    }'+#$D#$A;
  S:=S+'    getGui() {'+#$D#$A;
  S:=S+'        return this.gui;'+#$D#$A;
  S:=S+'    }'+#$D#$A;
  S:=S+'    getValue() {'+#$D#$A;
  S:=S+'        this.gui.focus();'+#$D#$A;
  S:=S+'    }'+#$D#$A;
  S:=S+'}'+#$D#$A;
  S:=S+'exports.TceNoneEditorComponent = TceNoneEditorComponent;'+#$D#$A;
  S:=S+''+#$D#$A;
  S:=S+'class TceCheckboxEditorComponent extends EditorComponentInputBase {'+#$D#$A;
  S:=S+'    init(params) {'+#$D#$A;
  S:=S+'        super.init(params);'+#$D#$A;
  S:=S+'        this.gui.type = "checkbox";'+#$D#$A;
  S:=S+'        this.gui.classList.add("ce-checkbox");'+#$D#$A;
  S:=S+'        super.postInit(params);'+#$D#$A;
  S:=S+'    }'+#$D#$A;
  S:=S+'}'+#$D#$A;
  S:=S+'exports.TceCheckboxEditorComponent = TceCheckboxEditorComponent;'+#$D#$A;
  S:=S+''+#$D#$A;
  S:=S+''+#$D#$A;
  S:=S+'/*'+#$D#$A;
  S:=S+'ceText,'+#$D#$A;
  S:=S+'ceNumber,'+#$D#$A;
  S:=S+'ceDate,'+#$D#$A;
  S:=S+'ceTime,'+#$D#$A;
  S:=S+'ceRange,'+#$D#$A;
  S:=S+'ceColor,'+#$D#$A;
  S:=S+'ceWeek,'+#$D#$A;
  S:=S+'ceMonth,'+#$D#$A;
  S:=S+'ceURL,'+#$D#$A;
  S:=S+'ceEmail,'+#$D#$A;
  S:=S+'ceTel,'+#$D#$A;
  S:=S+'ceMask,'+#$D#$A;
  S:=S+'ceCombo,'+#$D#$A;
  S:=S+'ceMemo,'+#$D#$A;
  S:=S+'ceNone,'+#$D#$A;
  S:=S+'ceCustom,'+#$D#$A;
  S:=S+'ceCheckbox,'+#$D#$A;
  S:=S+'ceCombobox,'+#$D#$A;
  S:=S+'ceDateTime,'+#$D#$A;
  S:=S+'cePicker,'+#$D#$A;
  S:=S+'ceColorPicker'+#$D#$A;
  S:=S+'*/'+#$D#$A;
  S:=S+'class TestRendererComponent extends TcrImageRendererComponent {'+#$D#$A;
  S:=S+'}'+#$D#$A;
  S:=S+'exports.TestRendererComponent = TestRendererComponent;'+#$D#$A;
  S:=S+'class TestEditorComponent extends TceNumberEditorComponent {'+#$D#$A;
  S:=S+'    init(params) {'+#$D#$A;
  S:=S+'        super.init(params);'+#$D#$A;
  S:=S+'        super.postInit(params);'+#$D#$A;
  S:=S+'    }'+#$D#$A;
  S:=S+'}'+#$D#$A;
  S:=S+'exports.TestEditorComponent = TestEditorComponent;'+#$D#$A;
  S:=S+''+#$D#$A;
{$ENDIF}
{$ENDREGION}
  Result := S;
end;

initialization

  TTMSModuleLoader.RegisterEmbeddedJavaScript(TDGCellComponents.Create);

end.
